/**
 * Sticky Text Swap
 *
 * Anima los elementos .line dentro de .sticky-head-info sincronizados con
 * el scroll de cada .sticky-section. Los datos (title, date, place, link)
 * se leen de los data-attributes de cada sección y se inyectan en los
 * elementos correspondientes (.sticky-title, .sticky-date, .sticky-place,
 * .sticky-link).
 *
 * Cada .line se encuentra dentro de un .masking-text (overflow:hidden)
 * que recorta el contenido fuera de su caja, logrando el efecto cropped.
 *
 * Requiere GSAP + ScrollTrigger (registrados globalmente en gsap.js).
 */
function stickyTextSwap() {
  const wrapper = document.querySelector('.sticky-wrapper')
  if (!wrapper) return

  const sections = wrapper.querySelectorAll('.sticky-section')
  if (!sections.length) return

  const headInfo = wrapper.querySelector('.sticky-head-info')
  if (!headInfo) return

  const titleEl = headInfo.querySelector('.sticky-title')
  const dateEl  = headInfo.querySelector('.sticky-date')
  const placeEl = headInfo.querySelector('.sticky-place')
  const linkEl  = headInfo.querySelector('.sticky-link')

  const lines = headInfo.querySelectorAll('.line')
  if (!lines.length) return

  // Helpers
  function updateContent(section) {
    if (titleEl) titleEl.textContent = section.dataset.title || ''
    if (dateEl)  dateEl.textContent  = section.dataset.date  || ''
    if (placeEl) placeEl.textContent = section.dataset.place || ''
    if (linkEl)  linkEl.href         = section.dataset.link  || '#'
  }

  // Estado inicial: datos de la primera sección, lines visibles
  updateContent(sections[0])
  gsap.set(lines, { yPercent: 0 })

  // Índice actual para controlar el swap en ambas direcciones
  let currentIndex = 0

  sections.forEach((section, index) => {
    // Solo crear transición si hay una siguiente sección
    const nextSection = sections[index + 1]
    if (!nextSection) return

    // Flag para saber qué contenido está mostrado en esta transición
    let swapped = false
    let swapTimer = null
    const swapDelay = 200

    // Timeline con scrub: salida → reposición → entrada
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'bottom 55%',
        end: 'bottom 10%',
        scrub: 2,
        onUpdate: (self) => {
          // Al pasar la mitad de la timeline, hacer swap con delay
          if (self.progress > 0.5 && !swapped) {
            swapped = true
            clearTimeout(swapTimer)
            swapTimer = setTimeout(() => updateContent(nextSection), swapDelay)
          }
          // Al volver antes de la mitad, restaurar con delay
          if (self.progress <= 0.5 && swapped) {
            swapped = false
            clearTimeout(swapTimer)
            swapTimer = setTimeout(() => updateContent(section), swapDelay)
          }
        }
      }
    })

    // SALIDA: lines suben y salen por arriba (cropped por masking-text)
    tl.to(lines, {
      yPercent: -100,
      duration: 1,
      ease: "power1.inOut"
    })

    // SWAP: Reposicionar lines abajo (instantáneo)
    tl.set(lines, { yPercent: 110 })

    // ENTRADA: lines suben desde abajo hacia posición natural (cropped)
    tl.to(lines, {
      yPercent: 0,
      duration: 1,
      ease: "power1.inOut"
    })
  })
}

export default stickyTextSwap
